<div class="modal-header" #createTicket>
  <h1 id="modal-title" class="modal-title">{{ "support.create_ticket" | translate }}</h1>
  <button ngbAutofocus class="close" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" ngbAutofocus>
  <myp-inline-loader [loading]="loading" height="200px" spinnerName="createTicketLoader"></myp-inline-loader>

  @if (!loading && !ticketResult) {
    <div>
      <div class="form-group">
        <label class="control-label mb-0" for="subject">{{ "support.subject" | translate }}*</label>
        <input type="text" class="form-control" [(ngModel)]="ticketArgs.subject" id="subject" required />
      </div>
      <div class="form-group">
        <label class="control-label mb-0" for="description">{{ "support.description" | translate }}*</label>
        <textarea class="form-control" [(ngModel)]="ticketArgs.body" id="description" required></textarea>
      </div>
      <div class="form-group">
        <label id="country-label" class="control-label mb-0" for="country">{{ "support.choose_country" | translate }}*</label>
        <span class="sr-only">The following text field filters the list of countries as you type. Use arrow keys to navigate through the results.</span>
        <input
          type="text"
          name="country"
          class="form-control"
          placeholder="{{ 'support.filter_country' | translate }}"
          (focus)="focusInput('country')"
          (blur)="inputBlur('country')"
          (keyup)="searchCountries($event)"
          [(ngModel)]="selectedCountry"
          id="country"
          required
          role="combobox"
          aria-autocomplete="list"
          [attr.aria-expanded]="searchingCountries"
          aria-controls="country-listbox"
          aria-haspopup="country-listbox"
          [attr.aria-activedescendant]="selectedCountry ?? ''"
        />
        <div aria-live="assertive" class="sr-only" id="country-status"></div>
      </div>
      <div style="position: relative">
        @if (searchingCountries) {
          <ul id="country-listbox" role="listbox" aria-labelledby="country-label" class="ticketfield-list">
            @for (country of filteredCountries; track country) {
              <li role="option" [id]="country | removeSpaces" (click)="selectCountry(country)" class="ticketfield-option">
                <span>{{ country }}</span>
              </li>
            }
          </ul>
        }
      </div>
      <div class="form-group">
        <label id="product-label" class="control-label mb-0" for="product">{{ "support.choose_product" | translate }}*</label>
        <span class="sr-only">The following text field filters the list of products as you type. Use arrow keys to navigate through the results.</span>
        <input
          type="text"
          name="product"
          class="form-control"
          placeholder="{{ 'support.filter_products' | translate }}"
          (focus)="focusInput('product')"
          (blur)="inputBlur('product')"
          (keyup)="searchProducts($event)"
          [(ngModel)]="selectedProduct"
          id="product"
          required
          role="combobox"
          aria-autocomplete="list"
          [attr.aria-expanded]="searchingProducts"
          aria-controls="products-listbox"
          aria-haspopup="products-listbox"
          [attr.aria-activedescendant]="selectedProduct ?? ''"
        />
        <div aria-live="assertive" class="sr-only" id="product-status"></div>
      </div>
      <div style="position: relative">
        @if (searchingProducts) {
          <ul id="products-listbox" role="listbox" aria-labelledby="product-label" class="ticketfield-list">
            @for (product of filteredProducts; track product) {
              <li role="option" [id]="product | removeSpaces" (click)="selectProduct(product)" class="ticketfield-option">
                <span>{{ product }}</span>
              </li>
            }
          </ul>
        }
      </div>
      <div class="form-group">
        <label id="os-label" class="control-label mb-0" for="os">{{ "support.choose_os" | translate }}*</label>
        <span class="sr-only">The following text field filters the list of operating systems as you type. Use arrow keys to navigate through the results.</span>
        <input
          type="text"
          name="os"
          class="form-control"
          placeholder="{{ 'support.filter_os' | translate }}"
          (focus)="focusInput('os')"
          (blur)="inputBlur('os')"
          (keyup)="searchOperatingSystems($event)"
          [(ngModel)]="selectedOperatingSystem"
          id="os"
          required
          role="combobox"
          aria-autocomplete="list"
          [attr.aria-expanded]="searchingOperatingSystems"
          aria-controls="operating-systems-listbox"
          aria-haspopup="cooperating-systemsuntry-listbox"
          [attr.aria-activedescendant]="selectedOperatingSystem ?? ''"
        />
        <div aria-live="assertive" class="sr-only" id="os-status"></div>
      </div>
      <div style="position: relative">
        @if (searchingOperatingSystems) {
          <ul id="operating-systems-listbox" role="listbox" aria-labelledby="os-label" class="ticketfield-list">
            @for (os of filteredOperatingSystems; track os) {
              <li role="option" [id]="os | removeSpaces" (click)="selectOperatingSystem(os)" class="ticketfield-option">
                <span>{{ os }}</span>
              </li>
            }
          </ul>
        }
      </div>
      <div class="form-group">
        <label id="ware-label" class="control-label mb-0" for="ware">{{ "support.choose_ware" | translate }}*</label>
        <span class="sr-only">The following text field filters the list of audio software as you type. Use arrow keys to navigate through the results.</span>
        <input
          type="text"
          name="ware"
          class="form-control"
          placeholder="{{ 'support.filter_ware' | translate }}"
          (focus)="focusInput('ware')"
          (blur)="inputBlur('ware')"
          (keyup)="searchAudioSoftware($event)"
          [(ngModel)]="selectedAudioSoftware"
          id="ware"
          required
          role="combobox"
          aria-autocomplete="list"
          [attr.aria-expanded]="searchingAudioSoftware"
          aria-controls="audio-software-listbox"
          aria-haspopup="audio-software-listbox"
          [attr.aria-activedescendant]="selectedAudioSoftware ?? ''"
        />
        <div aria-live="assertive" class="sr-only" id="ware-status"></div>
      </div>
      <div style="position: relative">
        @if (searchingAudioSoftware) {
          <ul id="audio-software-listbox" role="listbox" aria-labelledby="ware-label" class="ticketfield-list">
            @for (ware of filteredAudioSoftware; track ware) {
              <li role="option" [id]="ware | removeSpaces" (click)="selectAudioSoftware(ware)" class="ticketfield-option">
                <span>{{ ware }}</span>
              </li>
            }
          </ul>
        }
      </div>
      <div class="form-group">
        <label class="control-label mb-0" for="attachment">{{ "general.add_attachments" | translate }}</label>
        <input type="file" ng2FileSelect [uploader]="uploader" id="attachment" />
        <!-- <div>
        <small>Accepted file types: png, jpg, gif, pdf, doc, docx, odt, txt, xml, json, wav, mp4, mov</small>
      </div> -->
      </div>
      @if (isUploading) {
        <div role="status">
          <div class="text-center" style="position: relative">
            <span style="color: gray; font-size: 16px; text-align: center; font-family: var(--body-font); font-weight: bold">
              {{ "general.uploading" | translate }} {{ uploadingFile?.file?.name }}
            </span>
            <br />
            <br />
            <div style="display: inline-block; margin: auto">
              <round-progress
                [current]="uploadProgress"
                [max]="100"
                [color]="'#45ccce'"
                [background]="'#eaeaea'"
                [radius]="100"
                [stroke]="10"
                [semicircle]="false"
                [rounded]="true"
                [clockwise]="true"
                [responsive]="false"
                [duration]="250"
                [animation]="'easeInOutQuart'"
                [animationDelay]="0"
              ></round-progress>
            </div>
            <br />
            @if (!uploadingComplete) {
              <span class="uploading-label">{{ uploadProgress }}%</span>
            }
            @if (uploadingComplete && !fileResponse) {
              <span class="uploading-label">{{ "general.processing_dots" | translate }}</span>
            }
          </div>
        </div>
      }
      @if (attachments && attachments.length) {
        <div>
          <label class="control-label mb-0">Attachments</label>
          <ul class="list-group">
            @for (attachment of attachments; track attachment) {
              <li class="list-group-item p-0 bg-transparent border-0">
                {{ attachment.upload && attachment.upload.attachment && attachment.upload.attachment.file_name ? attachment.upload.attachment.file_name : "" }}
              </li>
            }
          </ul>
        </div>
      }
    </div>
  }

  @if (ticketResult) {
    <div class="text-center" role="status">
      <fa-icon icon="check-circle" style="color: green; font-size: 55px"></fa-icon>
      <br />
      <br />
      {{ "support.ticket_success" | translate }}
      <br />
      <br />
      <button type="button" class="btn btn-primary" (click)="viewTicket()">{{ "support.view_ticket" | translate }}</button>
    </div>
  }
</div>
<div class="modal-footer">
  @if (!ticketResult) {
    <button type="button" class="btn btn-primary" (click)="submit()">{{ "general.submit" | translate }}</button>
  }
  <button type="button" class="btn btn-blank" (click)="cancel()">{{ "general.close" | translate }}</button>
</div>
